module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-profile-kim.f5aa3fb.png";